import { AuthState } from './types'
import { getUser, getToken } from '@/utils/auth'

export const state: AuthState = {
  user: getUser(),
  token: getToken()
}